module.exports = __webpack_public_path__ + "static/media/cog-solid.67423012.svg";